import { render, staticRenderFns } from "./MaintenanceConfigDetail.vue?vue&type=template&id=1b09affc"
import script from "./MaintenanceConfigDetail.vue?vue&type=script&lang=js"
export * from "./MaintenanceConfigDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports